import { Engine } from '../engine/Engine'
import { Experience } from '../engine/Experience'
import { Resource } from '../engine/Resources'
import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer'
import './point.scss'
import { Color } from 'three'
import _ from 'lodash'
import { getChartData, getPointDetail } from '@/api'
import * as echarts from 'echarts';
import moment from 'moment'

export type Position = {
  px: number, // positon
  py: number,
  pz: number,
  rx: number, // rotate
  ry: number,
  rz: number,
  sx: number, // scale
  sy: number,
  sz: number,
}

export type Point = {
  id: number // point id
  name: string // point name
  status: boolean;
  path: string
  position?: Position
}


export class Points implements Experience {
  resources: Resource[] = []

  constructor(private engine: Engine, data: any[]) {

    data.forEach((item: Point) => {
      this.resources.push({
        key: `${item.id}`,
        name: item.name,
        status: Boolean(item.status),
        type: 'gltf',
        path: item.path,
        position: item.position
      })
    })

  }

  init() {
    // const models = this.resources.map((item: Resource) => this.engine.resources.getItem(item.name).scene);
    const models = this.resources.map((item: Resource) => {
      const model = this.engine.resources.getItem(item.key)
      model.traverse(function (node) {
        if (node.isMesh) {
          // 设置材质的透明度
          node.material.transparent = true;
          // node.material.color = 0x00ff00
          node.material.opacity = 0.6;
          // // 设置建筑物模型的材质属性
          // node.material.depthWrite = false;
          node.material.emissive = new Color(item['status'] ? 0xff0000 : 0x00ff00);
          // node.material.emissive = new Color(0x00ff00);
          node.material.emissiveIntensity = 1.0;
          node.material.needsUpdate = true;
        }
      })


      const element = document.createElement('div')
      element.className = 'terminal-box'
      element.id = `${item.key}`
      element.style.backgroundImage = 'url(https://zjbjtech.cn/api/assets/cloud/84387046-4711-4e19-ad44-0ba9301138c9)'
      element.innerText = `${item.name}`;
      const css2dObject = new CSS2DObject(element)
      model.add(css2dObject)


      !this.engine.disable && element.addEventListener('mousedown', (e) => {
        const id = (e.target as HTMLDivElement).getAttribute('id') || 0;
        getPointDetail(+id).then((res) => {
          const point = res.data;
          const timer = setTimeout(() => {
            clearTimeout(timer)
            let htmlText = `<p><b>监测点</b><span>${point.name}</span></p>`
            // 如果已存在 'terminal-info-pop' 直接替换显示内容即可，无需重新创建和绑定事件  避免内存泄漏
            const [exist] = Array.from(document.getElementsByClassName('terminal-info-pop')).filter((ele) => ele.parentNode === this.engine.canvas.parentElement)
            if (exist) {
              // 已存在 直接替换对应DOM数据
              htmlText += `<p><b>传感器</b><span>${point.sensor?.name}</span></p>`;
              htmlText += `<p><b>终端</b><span>${point.sensor?.terminal?.name}</span></p>`;
              if (point.data) {
                htmlText += `<p><b>电量</b><span>${point.data?.raw?.battery} %</span></p>`;
                // htmlText += `<p><b>${point.data?.raw?.label}</b><span>${point.data?.raw?.data} ${point.data?.raw?.unit}</span></p>`;
                point.data?.raw?.data.forEach((item) => {
                  htmlText += `<p><b>${point.label[item.key]}</b><span>${item.value} ${item.unit || point.unit}</span></p>`;
                });
                htmlText += `<p><b>更新于</b><span>${point.data?.raw?.time}</span></p>`;
                htmlText += `<p><b>报警</b><span style="color:${point.data?.warning ? '#F56C6C' : '#67C23A'}">${point.data?.warning || '正常'}</span></p>`;
              }
              //避免 tsc 报错 更新逻辑分步骤操作
              exist.querySelector('.terminal-info-content')?.remove()
              exist.insertAdjacentHTML('beforeend', `<div class="terminal-info-content">${htmlText}</div>`)
            } else {
              htmlText += `<p><b>传感器</b><span>${point.sensor?.name}</span></p>`;
              htmlText += `<p><b>终端</b><span>${point.sensor?.terminal?.name}</span></p>`;
              if (point.data) {
                htmlText += `<p><b>电量</b><span>${point.data?.raw?.battery} %</span></p>`;
                point.data?.raw?.data.forEach((item) => {
                  htmlText += `<p><b>${point.label[item.key]}</b><span>${item.value} ${item.unit || point.unit}</span></p>`;
                });
                htmlText += `<p><b>更新于</b><span>${point.data?.raw?.time}</span></p>`;
                htmlText += `<p><b>报警</b><span style="color:${point.data?.warning ? '#F56C6C' : '#67C23A'}">${point.data?.warning || '正常'}</span></p>`;
              }
              const popBox = document.createElement('div')
              popBox.className = 'terminal-info-pop'
              const btn = document.createElement('span')
              btn.className = 'pop-btn-close'
              btn.innerText = '×'
              btn.onclick = () => {
                btn.onclick = null
                popBox.remove()
              }
              popBox.appendChild(btn)
              popBox.insertAdjacentHTML('beforeend', `<div class="terminal-info-content">${htmlText}</div>`)
              this.engine.canvas.parentElement?.appendChild(popBox)
            }
          }, 300)
          return point;
        }).then((detail) => {


          const timer = setTimeout(() => {
            clearTimeout(timer)
            // 如果已存在 'terminal-info-pop' 直接替换显示内容即可，无需重新创建和绑定事件  避免内存泄漏
            const [exist] = Array.from(document.getElementsByClassName('terminal-chart-pop')).filter((ele) => ele.parentNode === this.engine.canvas.parentElement)
            if (!exist) {
              const popBox = document.createElement('div')
              popBox.className = 'terminal-chart-pop';
              const btn = document.createElement('span')
              btn.className = 'pop-btn-close'
              btn.innerText = '×'
              btn.onclick = () => {
                btn.onclick = null
                popBox.remove()
              }
              popBox.appendChild(btn)
              popBox.insertAdjacentHTML('beforeend', `<div id="terminal-chart-content">--</div>`)
              this.engine.canvas.parentElement?.appendChild(popBox);
            }

            // 添加历史曲线功能
            getChartData(+id).then((res) => {
              const data = res.data.map((item: { raw: { data: number }; collectTime: string }) => {
                return {
                  values: item.raw.data,
                  collectTime: moment(item.collectTime).format('YYYY-MM-DD HH:mm:ss')
                }
              })
              if (data.length > 0) {


                const option = {
                  backgroundColor: 'rgba(3, 11, 51,0.85)',
                  tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                      type: 'cross',
                      label: {
                        backgroundColor: '#6a7985'
                      }
                    }
                  },
                  grid: { left: '6%', right: '6%', containLabel: true },
                  dataZoom: [
                    {
                      type: 'inside',
                      start: 0,
                      end: 100,
                    },
                    {
                      start: 0,
                      end: 100
                    },
                  ],
                  legend: {
                    data: [] as any[]
                  },
                  xAxis: {
                    type: 'category',
                    data: data.map((item: { collectTime: Date }) => {
                      return item['collectTime']
                    })
                  },
                  yAxis: {
                    max: function (value: { max: number; min: number; }) {
                      return Math.abs(value.max) > 10 ? Math.ceil(value.max + (value.max - value.min) * 0.1) : (value.max + (value.max - value.min) * 0.1).toFixed(3);
                    },
                    min: function (value: { min: number; max: number; }) {
                      return Math.abs(value.min) > 10 ? Math.floor(value.min - (value.max - value.min) * 0.1) : (value.min - (value.max - value.min) * 0.1).toFixed(3);
                    },
                    type: 'value',
                  },
                  series: [] as any[],
                }

                const dataMapper = {};
                // 取出公共的X轴时间表
                // 过滤出对应label下的所有数据，分别按照不同的折线图显示
                for (const key in detail.label) {
                  const label = detail.label[key];
                  option.legend.data.push(label);
                  dataMapper[key] = []; // 用于存放 line data
                }
                for (let i = 0; i < data.length; i++) {
                  const item = data[i];
                  if (Array.isArray(item.values)) {
                    item.values.forEach((i: { key: string, value: string }) => {
                      if (Array.isArray(dataMapper[i.key]) && !isNaN(i.value as any)) {
                        dataMapper[i.key].push(i.value)
                      }
                    })

                  }
                }
                for (const key in dataMapper) {
                  const label = detail.label[key];
                  option.series.push({
                    name: label,
                    type: 'line',
                    data: dataMapper[key],
                    symbol: 'none',
                    smooth: true,
                    animation: {
                      duration: 1000, // 动画时长
                      easing: 'cubicOut', // 缓动函数
                    }
                  })
                }

                const dom = document.getElementById('terminal-chart-content');
                if (dom) {
                  echarts.init(dom, { resize: true }).setOption(option);
                }
              }
            })

          }, 300)


        })



      })


      //  姿态
      model.rotation.set(item.position?.rx, item.position?.ry, item.position?.rz)
      model.position.set(item.position?.px, item.position?.py, item.position?.pz)
      model.scale.set(item.position?.sx, item.position?.sy, item.position?.sz)

      return model
    });

    models.length > 0 && this.engine.scene.add(...models)

  }

  updateResources(resources: Resource[] | Resource) {
    // console.log('updateResources', resources)
    if (Array.isArray(resources)) {
      resources.forEach((item) => {
        const resource = this.resources.find((r) => r.key === item.key);
        resource && Object.assign(resource, {
          status: Boolean(item['status']),
        })
        const model = this.engine.resources.getItem(item.key)
        model.traverse(function (node) {
          if (node.isMesh) {
            // 设置材质的透明度
            node.material.transparent = true;
            // node.material.color = 0x00ff00
            node.material.opacity = 0.6;
            // // 设置建筑物模型的材质属性
            // node.material.depthWrite = false;
            node.material.emissive = new Color(item['status'] ? 0xff0000 : 0x00ff00);
            node.material.emissiveIntensity = 1.0;
            node.material.needsUpdate = true;
          }
        })

        // model.rotation.set(item.position?.ax, item.position?.ay, item.position?.az)
        // model.position.set(item.position?.px, item.position?.py, item.position?.pz)
      })
    }
    // if (Array.isArray(resources)) {
    // 1、删除多余的模型
    // 2、更新相同的
    // 3、添加新模型
    // 比较 status 和 position 发生变化的
    // const oldKeys = Object.keys(this.engine.resources.items).filter((key: string) => !isNaN(+key)); // 使用 key 是否为 point.id 数字字符串类型判断监测点
    // const newKeys = resources.map((item: Resource) => item.key)
    // console.log(oldKeys, newKeys)
    // const deleteKeys = _.difference(oldKeys, newKeys);
    // const updateKeys = _.intersection(oldKeys, newKeys);
    // const addKeys = _.difference(newKeys, oldKeys);
    // console.log('add keys', addKeys)
    // if (deleteKeys.length > 0) {
    //   // 删除
    //   this.resources = this.resources.filter(({ key }) => deleteKeys.includes(key));
    //   this.engine.scene.remove(...deleteKeys.map((key) => this.engine.resources.getItem(key)))
    //   this.engine.resources.deleteItem(...deleteKeys)
    // }
    // if (updateKeys.length > 0) {
    //   // 更新
    //   const updateReources = resources.filter((item) => updateKeys.includes(item.key));
    //   updateReources.forEach((item) => {
    //     const resource = this.resources.find((r) => r.key === item.key);
    //     resource && Object.assign(resource, {
    //       status: Boolean(item['status']),
    //       path: item.path,
    //       position: item.position
    //     })
    //     // const model = this.engine.resources.getItem(item.key)
    //     // model.rotation.set(item.position?.ax, item.position?.ay, item.position?.az)
    //     // model.position.set(item.position?.px, item.position?.py, item.position?.pz)
    //   })
    // }
    // if (addKeys.length > 0) {
    //   // 添加
    //   const addReources = resources.filter((item) => addKeys.includes(item.key));
    //   this.engine.resources.addItem(...addReources).then(() => {
    //     console.log('add loaded')
    //     this.resources.push(...addReources)

    //     const models = addReources.map((item: Resource) => {
    //       const model = this.engine.resources.getItem(item.key)
    //       model.scale.set(50, 50, 50)

    //       model.traverse(function (node) {
    //         if (node.isMesh) {
    //           // 设置材质的透明度
    //           node.material.transparent = true;
    //           // node.material.color = 0x00ff00
    //           node.material.opacity = 0.6;
    //           // // 设置建筑物模型的材质属性
    //           // node.material.depthWrite = false;
    //           node.material.emissive = new Color(0x00ff00);
    //           node.material.emissiveIntensity = 1.0;
    //           node.material.needsUpdate = true;
    //         }
    //       })


    //       const element = document.createElement('div')
    //       element.className = 'terminal-box'
    //       element.id = `${item.name}`
    //       element.style.backgroundImage = 'url(https://sunrainmeta.com/api/assets/cloud/3867c63b-afdb-4d35-8c4d-7be1a561fba0.png)'
    //       const name = document.createElement('b')
    //       name.innerText = `${item.name}`
    //       element.appendChild(name)
    //       const css2dObject = new CSS2DObject(element)
    //       model.add(css2dObject)
    //       // model.rotation.set(item.position?.ax, item.position?.ay, item.position?.az)
    //       // model.position.set(item.position?.px, item.position?.py, item.position?.pz)

    //       return model
    //     });

    //     models.length > 0 && this.engine.scene.add(...models)

    //   })
    // }
    // this.engine.resources.forEach((resource: Resource) => {

    // })
    // } else {
    //   // update one point
    //   const resource = this.resources.find((r) => r.key === resources.key);
    //   resource && Object.assign(resource, {
    //     status: Boolean(resources['status']),
    //     path: resources.path,
    //     position: resources.position
    //   })
    //   // const model = this.engine.resources.getItem(resources.key)
    //   // model.rotation.set(resources.position?.ax, resources.position?.ay, resources.position?.az)
    //   // model.position.set(resources.position?.px, resources.position?.py, resources.position?.pz)
    // }
  }

  resize() { }

  update() { }
}
